import React from 'react';
import style from './moreLessText.module.scss';
import classNames from 'classnames';
import { Dispatch, SetStateAction } from 'react';
import {FormattedMessageForLess, FormattedMessageForMore} from 'acscp/components/common/moreLessText';

interface MoreLessTextProps {
    text?: string;
    unsafeHTML?: string;
    minimumLines?: number;
    handleChange: Dispatch<SetStateAction<boolean>>;
    expanded: boolean;
    shouldRenderMoreLessButton: boolean;
}

export class MoreLessWrapper extends React.Component<MoreLessTextProps> {
    constructor(props: MoreLessTextProps) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <div className={classNames(style.Text, {[style.HTML]: !!this.props.unsafeHTML})}>
                {this.props.children}
                {this.props.shouldRenderMoreLessButton && !this.props.expanded && (
                    <span>
                        <a className={style.More} onClick={() => this.props.handleChange(pv => !pv)}>
                            <FormattedMessageForMore />
                            <div className={style.Triangle} />
                        </a>
                    </span>
                )}
                {this.props.shouldRenderMoreLessButton && this.props.expanded && (
                    <span>
                        <a className={style.Less} onClick={() => this.props.handleChange(pv => !pv)}>
                            <FormattedMessageForLess />
                            <div className={style.InvertedTriangle} />
                        </a>
                    </span>
                )}
            </div>
        );
    }
}
